// Helpers and Utils
//import { media } from '../../utils/MediaQueries';

// Accordion
import accordion from '../../template-parts/parts/accordion';


// Animations
import scrollAnimations from './scrollAnimations'
//import gsapAnimations from './gsap-animations'
import sliders from './sliders'

// Components and Blocks
//import blockX from './../../template-parts/blocks/blockX'


function consoleMessage(){
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}


/* *********************** */
/* Start all the functions */
/* *********************** */

function init() {
	// Init
	consoleMessage()
	usingJS()

	accordion();

	// Animations
	scrollAnimations()
	//gsapAnimations()
	sliders()
}
init();




jQuery(document).ready(function ($) {

    magnific: { 
        // GALLERY IMAGE
        $('.magnific-gallery-image').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
                verticalFit: true,
                titleSrc: function(item) {
                    return item.el.attr('title');
                }
            },
            gallery:{
                enabled:true
            }
		});
	}
    
	anchorlinks: {
		$(document).on('click', '.scroll-to', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top
			}, 500);
		});
	}

    mobileMenu: {
		$(function() {
            $(".toggle-menu").click(function() {
            $(this).toggleClass("active");
            $('.menu-drawer').toggleClass("open");
            });
        });
	}

	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass('no-force-blank');
		});	 
		
		$('a:not(.no-force-blank):not(.vbox-item):not([class^="magnific-"])').each(function () {
			var a = new RegExp('/' + window.location.host + '/');
			
			if (!a.test(this.href)) {
				$(this).click(function (event) {
				event.preventDefault();
				window.open(this.href, '_blank');
				});
			}
		});
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}
});


